import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IMerchantPartnerAddRequest {
  merchantId?: number;
  officialFullName?: string;
  officialCitizenNumber?: string;
    officialMobilePhone?: string;
    officialBirthDate?: string | null;
  
    partnerOneFullName?: string;
  partnerOneCitizenNumber?: string;
  partnerOneMobilePhone?: string;
  partnerOneBirthDate?: string | null;
  partnerOnePercent?: number;
  partnerOneType?: string;

  partnerTwoFullName?: string;
partnerTwoCitizenNumber?: string;
partnerTwoMobilePhone?: string;
partnerTwoBirthDate?: string | null;
partnerTwoPercent?: number;
partnerTwoType?: string;

partnerThreeFullName?: string;
partnerThreeCitizenNumber?: string;
partnerThreeMobilePhone?: string;
partnerThreeBirthDate?: string | null;
partnerThreePercent?: number;
partnerThreeType?: string;

partnerFourFullName?: string;
partnerFourCitizenNumber?: string;
partnerFourMobilePhone?: string;
partnerFourBirthDate?: string | null;
partnerFourPercent?: number;
partnerFourType?: string;

partnerFiveFullName?: string;
partnerFiveCitizenNumber?: string;
partnerFiveMobilePhone?: string;
partnerFiveBirthDate?: string | null;
partnerFivePercent?: number;
partnerFiveType?: string;
}

async function merchantPartnerAdd(
  data: IMerchantPartnerAddRequest
): Promise<any> {
  try {
    return (await axiosInstance.post("/MerchantPartner/add", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useMerchantPartnerAdd() {
  return useMutation<any, Error, IMerchantPartnerAddRequest>((variables) =>
    merchantPartnerAdd(variables)
  );
}
